import styled from "@emotion/styled";

import { fontMerriweather, fontRobotoCondensed, theme } from "shared/lib/styles";

import { Figure } from "scmp-app/components/content/content-cover-image/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const StyledEntityLink = styled(EntityLink)`
  display: block;

  color: #000000;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${theme.breakpoints.between("tablet", "desktop")} {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 20px;
    align-items: start;
  }

  ${theme.breakpoints.up("desktop")} {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;

export const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  min-inline-size: 0;
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  min-inline-size: 0;
`;

export const SectionLabel = styled.div`
  color: #333333;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;

  &:empty {
    display: none;
  }
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 17px;
  font-family: ${fontMerriweather};
  line-height: 1.4;
`;

export const Summary = styled.div`
  color: #5a5a5a;
  font-weight: 400;
  font-size: 13px;
  font-family: ${fontMerriweather};
  line-height: 1.5;

  &:empty {
    display: none;
  }
`;

export const CoverImage = styled.div`
  min-inline-size: 0;

  ${Figure} {
    aspect-ratio: 3 / 2;
  }
`;
